import { render, staticRenderFns } from "./InformationPageBlock.vue?vue&type=template&id=1dd23798&scoped=true&"
import script from "./InformationPageBlock.vue?vue&type=script&lang=js&"
export * from "./InformationPageBlock.vue?vue&type=script&lang=js&"
import style0 from "./InformationPageBlock.vue?vue&type=style&index=0&id=1dd23798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd23798",
  null
  
)

export default component.exports